import PencomTextField from "@/components/input/PencomTextField";

import type { ComponentType, ReactElement } from "react";

type EmployerDetailsField = {
  name: string;
  state: {
    value: string;
    meta: {
      errors: string[];
    };
  };
  handleChange: (value: string) => void;
};

type ContactFieldName =
  | "emailAddress"
  | "phoneNumber"
  | "directorName"
  | "directorEmail";

type EmployerDetailsFieldValidators = {
  onChange: (args: { value: string }) => string | undefined;
};

type EmployerDetailsFormLike = {
  Field: ComponentType<{
    name: ContactFieldName;
    validators?: EmployerDetailsFieldValidators | undefined;
    children: (field: unknown) => ReactElement;
  }>;
};

export interface EmployerDetailsContactFieldsSectionProps {
  form: EmployerDetailsFormLike;
}

export const EmployerDetailsContactFieldsSection = ({
  form,
}: EmployerDetailsContactFieldsSectionProps) => {
  return (
    <>
      <div className="flex flex-row gap-x-11">
        <div className="flex-1">
          <form.Field
            name="emailAddress"
            validators={{
              onChange: ({ value }: { value: string }) => {
                if (!value) return "Email Address is required";
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value))
                  return "Please enter a valid email address";
                return undefined;
              },
            }}
            children={(field: unknown) => {
              const f = field as EmployerDetailsField;
              return (
                <PencomTextField
                  id={f.name}
                label="Email Address"
                placeholder="Enter email address"
                type="email"
                  value={f.state.value}
                  onChange={(e) => f.handleChange(e.target.value)}
                bg="white"
                  error={!!f.state.meta.errors.length}
                  helperText={f.state.meta.errors.join(", ")}
                />
              );
            }}
          />
        </div>
        <div className="flex-1">
          <form.Field
            name="phoneNumber"
            validators={{
              onChange: ({ value }: { value: string }) => {
                if (!value) return "Phone Number is required";
                if (!/^\+?\d{10,15}$/.test(value))
                  return "Please enter a valid phone number";
                return undefined;
              },
            }}
            children={(field: unknown) => {
              const f = field as EmployerDetailsField;
              return (
                <PencomTextField
                  id={f.name}
                label="Phone Number"
                placeholder="Enter phone number"
                type="tel"
                  value={f.state.value}
                  onChange={(e) => f.handleChange(e.target.value)}
                bg="white"
                  error={!!f.state.meta.errors.length}
                  helperText={f.state.meta.errors.join(", ")}
                />
              );
            }}
          />
        </div>
      </div>

      <div className="flex flex-row gap-x-11">
        <div className="flex-1">
          <form.Field
            name="directorName"
            validators={{
              onChange: ({ value }: { value: string }) => {
                if (!value) return "Director Name is required";
                return undefined;
              },
            }}
            children={(field: unknown) => {
              const f = field as EmployerDetailsField;
              return (
                <PencomTextField
                  id={f.name}
                label="Director Name"
                placeholder="Enter director name"
                type="text"
                  value={f.state.value}
                  onChange={(e) => f.handleChange(e.target.value)}
                bg="white"
                  error={!!f.state.meta.errors.length}
                  helperText={f.state.meta.errors.join(", ")}
                />
              );
            }}
          />
        </div>

        <div className="flex-1">
          <form.Field
            name="directorEmail"
            validators={{
              onChange: ({ value }: { value: string }) => {
                if (!value) return "Director Email is required";
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value))
                  return "Please enter a valid email address";
                return undefined;
              },
            }}
            children={(field: unknown) => {
              const f = field as EmployerDetailsField;
              return (
                <PencomTextField
                  id={f.name}
                label="Director Email Address"
                placeholder="Enter director email"
                type="email"
                  value={f.state.value}
                  onChange={(e) => f.handleChange(e.target.value)}
                bg="white"
                  error={!!f.state.meta.errors.length}
                  helperText={f.state.meta.errors.join(", ")}
                />
              );
            }}
          />
        </div>
      </div>
    </>
  );
};

